import validator from '../utils/validator';

export const ValidatorIssues = validator.ZodIssueCode;

export type RefinementContext = validator.RefinementCtx;

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export type Refinement<T = any> = validator.Refinement<T>;
